export const FLEET_TABS = [
  { value: 'overview', label: 'Overview' },
  { value: 'history', label: 'Order History' },
  { value: 'maintenance', label: 'Maintenance' },
] as const;

export type FleetTabValue = (typeof FLEET_TABS)[number]['value'];

export const DEFAULT_FLEET_TAB: FleetTabValue = FLEET_TABS[0].value;

/** Query param used to persist the open drone across reloads on Fleet. */
export const DRONE_ID_QUERY_KEY = 'droneId';
